export default __webpack_public_path__ + "static/media/test1.2b9e5884.jpg";